import { useState } from "react";
import Svg from "./Svg";

export default function PriceAndCart(props) {
    const [num, setNum] = useState(0);

    function addNum() {
        setNum(num + 1);
    }

    function minusNum() {
        if (num === 0) {
            return setNum(0);
        } else {
            setNum(num - 1);
        }
    }

    return (
        <div>
            <div className="price">
                <h1>$125.00</h1>
                <div className="discount">
                    <p>50%</p>
                </div>
                <p>$250.00</p>
            </div>
            <div className="cart">
                <p onClick={minusNum}>
                    <Svg class="cart-plus-minus" name="minus" />
                </p>
                <p className="amount">{num}</p>
                <p onClick={addNum}>
                    <Svg class="cart-plus-minus" name="plus" />
                </p>
            </div>

            <button
                onClick={() => {
                    props.handleQuantity(num);
                }}
                className="add-btn"
            >
                <Svg class="btn-svg" name="cart" /> Add to cart
            </button>
        </div>
    );
}
